import { render, staticRenderFns } from "./Bulk-Reassign-Schedule.vue?vue&type=template&id=54a24468"
import script from "./Bulk-Reassign-Schedule.vue?vue&type=script&lang=js"
export * from "./Bulk-Reassign-Schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports